import _ from "lodash";
import React from "react";
import classes from "./ResponseItem.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import Textview from "UIComponents/Textview";
import classNames from "classnames";
import { colors } from "Constants";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { compose } from "lib/apolloClient";

const styles = {
  profileCascade: {
    width: 32,
    height: 32,
  },
};

const ResponseItem = ({ item, t }) => {
  const { message, evidence, createdBy } = item;
  const evidencesCount = _.size(evidence);
  const customTextStyle = { color: colors.textSubtle };
  const { id: creatorId, firstName, profileImage } = createdBy;
  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <ProfileCascade
          customStyle={styles.profileCascade}
          items={[{ id: creatorId, value: firstName, imageUrl: profileImage }]}
        />
        <div
          className={classNames({
            [classes.nameText]: true,
            ["heading-6"]: true,
          })}
        >
          {getFormattedUserName({ user: createdBy })}
        </div>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.richText} />
        {message && (
          <Textview
            mode={"view"}
            value={message}
            showViewEmpty={false}
            isWordWrapRequired={true}
            customTextStyle={customTextStyle}
          />
        )}
        {evidencesCount > 0 && (
          <div className={classes.evidenceCount}>{`${t(
            "common:evidence_count_interval",
            {
              postProcess: "interval",
              count: evidencesCount,
            }
          )} ${t("common:attached")}`}</div>
        )}
      </div>
    </div>
  );
};

export default compose(I18nHOC({ resource: "common" }))(ResponseItem);
